
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// classes
import { DataState } from '@/core/classes/DataState.class'

// types
import { CompanyT } from '@/core/types/companies.types'

// realisations
import { companies } from '@/core/realisations/companies.realisation'

export default defineComponent({
    components: {
        'the-input': TheInput,
        'the-select': TheSelect,
        'the-button': TheButton,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['resetted', 'search'],
    setup(props, { emit }) {
        const state = reactive({
            companyId: null as string | null,
            actNumber: null as string | null,
            actFrom1CCreatedAtFrom: null as string | null,
            actFrom1CCreatedAtTo: null as string | null,
        })

        const data_state = reactive({
            companies: new DataState<CompanyT>({}),
        })

        const reset = () => {
            if (props.loading) return

            state.companyId = null
            state.actNumber = null
            state.actFrom1CCreatedAtFrom = null
            state.actFrom1CCreatedAtTo = null

            emit('resetted')
        }

        const search = () => {
            if (props.loading) return

            emit('search', {
                companyId: state.companyId,
                actNumber: state.actNumber,
                actFrom1CCreatedAtFrom: state.actFrom1CCreatedAtFrom,
                actFrom1CCreatedAtTo: state.actFrom1CCreatedAtTo,
            })
        }

        const loadCompanies = async (page: number) => {
            data_state.companies.pagination.current_page = page

            try {
                data_state.companies.is_loading = true
                const response = await companies.getList({ page, statusId: 2, isExtended: 0 })
                data_state.companies.list = response.data

                data_state.companies.pagination.total_pages = response.meta.last_page

                data_state.companies.is_failed = false
                data_state.companies.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.companies.failure.catchError(error)

                if (!data_state.companies.failure.error_state.is_cancel) {
                    data_state.companies.is_failed = true
                }
            } finally {
                if (!data_state.companies.failure.error_state.is_cancel) {
                    data_state.companies.is_loading = false
                }
            }
        }

        const loadMoreCompanies = async (page: number) => {
            if (page > data_state.companies.pagination.total_pages) return
            data_state.companies.pagination.current_page = page

            try {
                data_state.companies.is_loading = true

                const response = await companies.getList({ page, statusId: 2, isExtended: 0 })
                data_state.companies.list = data_state.companies.list.concat(response.data)

                data_state.companies.pagination.total_pages = response.meta.last_page

                data_state.companies.is_failed = false
                data_state.companies.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.companies.failure.catchError(error)

                if (!data_state.companies.failure.error_state.is_cancel) {
                    data_state.companies.is_failed = true
                }
            } finally {
                if (!data_state.companies.failure.error_state.is_cancel) {
                    data_state.companies.is_loading = false
                }
            }
        }

        onBeforeMount(() => {
            loadCompanies(1)
        })

        return {
            state,
            data_state,
            reset,
            search,
            loadCompanies,
            loadMoreCompanies,
        }
    },
})
